import { render, staticRenderFns } from "./viewDetailsDialog.vue?vue&type=template&id=5875990e&scoped=true"
import script from "./viewDetailsDialog.vue?vue&type=script&lang=js"
export * from "./viewDetailsDialog.vue?vue&type=script&lang=js"
import style0 from "./viewDetailsDialog.vue?vue&type=style&index=0&id=5875990e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5875990e",
  null
  
)

export default component.exports